__turbopack_context__.v({
  "action": "SiteHeader-module__mdpVJq__action",
  "glyph": "SiteHeader-module__mdpVJq__glyph",
  "header": "SiteHeader-module__mdpVJq__header",
  "inner": "SiteHeader-module__mdpVJq__inner",
  "mark": "SiteHeader-module__mdpVJq__mark",
  "menu": "SiteHeader-module__mdpVJq__menu",
  "menuButton": "SiteHeader-module__mdpVJq__menuButton",
  "menuPanel": "SiteHeader-module__mdpVJq__menuPanel",
  "nav": "SiteHeader-module__mdpVJq__nav",
  "navLink": "SiteHeader-module__mdpVJq__navLink",
  "phoneAction": "SiteHeader-module__mdpVJq__phoneAction",
  "phoneControls": "SiteHeader-module__mdpVJq__phoneControls",
  "reset": "SiteHeader-module__mdpVJq__reset",
  "skipLink": "SiteHeader-module__mdpVJq__skipLink",
  "wideNav": "SiteHeader-module__mdpVJq__wideNav",
  "wordmark": "SiteHeader-module__mdpVJq__wordmark",
});
